import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import { TokenRefreshContext, ResponseType } from '../../Contexts/TokenRefreshContext';
import authService from '../../api-authorization/AuthorizeService';
import { AlertContext } from '../../Contexts/AlertContext';
import { useForm } from 'react-hook-form';
import LoadingButton from '@mui/lab/LoadingButton';
import CreatePartyViewmodel from '../ViewModels/CreatePartyViewmodel';

interface IProps {
    open: boolean;
    onClose: (refresh: boolean) => void;
}

export default function CreateProject(props: IProps) {
    const { crabFetch } = React.useContext(TokenRefreshContext);
    const { show } = React.useContext(AlertContext);
    const { open, onClose } = props;
    const [loading, setLoading] = React.useState(false);
    const [newParty] = React.useState<CreatePartyViewmodel>(new CreatePartyViewmodel());

    const formContext = useForm<CreatePartyViewmodel>({
        defaultValues: new CreatePartyViewmodel()
    });

    const { reset } = formContext;

    React.useEffect(() => {
        setLoading(false);
    }, []);

    React.useEffect(() => {
        reset(newParty);
    }, [newParty]);

    const submit = async (form: any) => {
        const token = await authService.getAccessToken();

        crabFetch('InstructingParty/CreateInstructingParty', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json; charset=utf-8' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json; charset=utf-8' },
            body: JSON.stringify(form)
        }, ResponseType.Text,
            (data: any) => {
                if (data.length > 0) show('error', data);
                else {
                    show('success', "Successfully created Instructing Party");
                    onClose(true);
                }
            },
            (error: any) => {
                show('error', error);
            }
        );
    }

    return (
        <Dialog
            open={open}
            onClose={() => onClose(false)}
            maxWidth="xs"
            fullWidth
        >
            <FormContainer
                onSuccess={submit}
            >
                <DialogTitle>{"Create Instructing Party"}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <InputLabel htmlFor="companyName" shrink>Company Name</InputLabel>
                            <TextFieldElement name="companyName" required fullWidth size="small" />
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel htmlFor="contactName" shrink>Contact Name</InputLabel>
                            <TextFieldElement name="contactName" required fullWidth size="small" />
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel htmlFor="jobTitle" shrink>Job Title</InputLabel>
                            <TextFieldElement name="jobTitle" required fullWidth size="small" />
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel htmlFor="email" shrink>Email</InputLabel>
                            <TextFieldElement parseError={() => "Please enter a valid email address"} type={'email'} name="email" required fullWidth size="small" />
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel htmlFor="office" shrink>Office</InputLabel>
                            <TextFieldElement name="office" required fullWidth size="small" />
                        </Grid>
                        
                    </Grid>
                    <DialogActions>
                        <Button onClick={() => onClose(false)} color="error" disabled={loading}>Cancel</Button>
                        <LoadingButton variant="contained" type="submit" loading={loading}>{"Create"}</LoadingButton>
                    </DialogActions>
                </DialogContent>
            </FormContainer>
        </Dialog>
    );
}